import { ApiBase } from '@/api/api'
import { makeGetRequest } from '@/api/fetchCalls'
import type {
  SingleQuestionFiltersModel,
  SingleQuestionType,
} from '@/domain/model/question'

export const loadQuestionsByResourceId = async (
  params: SingleQuestionFiltersModel
): Promise<SingleQuestionType[]> => {
  return await makeGetRequest(ApiBase + `/questions`, {
    params,
  })
}
